export * from './i18n.js';